import React, {useState} from "react";
import {CButton} from "@coreui/react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faRunning } from '@fortawesome/free-solid-svg-icons'

const CancelButton = ({value , onClick}) => {

  return(
    <>
      <CButton className="btn btn-outline-warning" onClick={onClick}>
        <FontAwesomeIcon icon={faRunning}/>{` `}{value ? value : 'Cancel'}
      </CButton>
    </>
  )
}
export default CancelButton
